<div class="bannerback">
    <!-- <app-nav></app-nav> -->
</div>
<!-- SECTION PAGE 1 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Create Vendor</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num-active">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>
        <div class="white-box">
            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Location</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Classification</h5>
                        <div class="d-flex">
                            <div class="classification-btn-active">
                                Internal
                            </div>
                            &nbsp;
                            <div class="classification-btn-Dactive">
                                External
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">PM Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">PM Email</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">PM Mobile</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
            </div>

            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Alternative PM Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Alternative PM Email</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Alternative PM Mobile</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="submmit-btn">Create</button>
        </div>

        <div class="my-5">
            <h4 class="large-h mb-0">Vendor List</h4>
            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-w-100">
                    <div class="number-box">
                        01
                    </div>
                    <img class="row-img"
                        src="https://plus.unsplash.com/premium_photo-1698952193484-46baa98c764c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMnx8fGVufDB8fHx8fA%3D%3D"
                        alt="loading">
                    <h5 class="medium-h-row">Wilson Jacson</h5>
                </div>
                <div class="d-flex flex-wrap mob-m-t-b-1rem">
                    <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon William</div>
                    <div class="detail-box"><i class="pi pi-user icon-ml"></i>Internal</div>
                    <div class="detail-box"><i class="fa fa-location-dot icon-ml"></i>Location</div>
                    <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                    <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>

            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-w-100">
                    <div class="number-box">
                        01
                    </div>
                    <img class="row-img"
                        src="https://plus.unsplash.com/premium_photo-1698952193484-46baa98c764c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMnx8fGVufDB8fHx8fA%3D%3D"
                        alt="loading">
                    <h5 class="medium-h-row">Wilson Jacson</h5>
                </div>
                <div class="d-flex flex-wrap mob-m-t-b-1rem">
                    <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon William</div>
                    <div class="detail-box"><i class="pi pi-user icon-ml"></i>Internal</div>
                    <div class="detail-box"><i class="fa fa-location-dot icon-ml"></i>Location</div>
                    <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                    <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- SECTION PAGE 1 End -->

<!-- SECTION PAGE 2 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Responsible</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num-active">02</span>
                        <span class="pg-num">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Email</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">

                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Mobile</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">

                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="submmit-btn">Create</button>
        </div>

        <div class="my-5">
            <h4 class="large-h mb-0 m-top-15">Responsible List</h4>
            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-column">
                    <div class="d-flex mob-w-100">
                        <div class="number-box">
                            01
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mob-m-t-b-1rem">
                        <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon Lipshutz</div>
                        <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                        <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                        <div class="detail-box-purple">Senior Responsible</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>

            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-column">
                    <div class="d-flex mob-w-100">
                        <div class="number-box">
                            02
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mob-m-t-b-1rem">
                        <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon Lipshutz</div>
                        <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                        <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                        <div class="detail-box-purple-border">Senior Responsible</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>
        </div>

    </div>
</section>
<!-- SECTION PAGE 2 End -->

<!-- SECTION PAGE 3 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Create Project</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="d-flex p-l-r-2rem">
                        <div class="column mx-1 my-2 width-100">
                            <h5 class="medium-h">Start Time</h5>
                            <div class="time-box">08-10-2023</div>
                        </div>
                        <div class="column mx-1 my-2 width-100">
                            <h5 class="medium-h">End Time</h5>
                            <div class="time-box">10-11-2023</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Mobile</h5>
                        <div>
                            <select class="ms-dropdown-pg-3">
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                              <option [value]="'option'">option</option>
                            </select>
                          </div>
                    </div>
                </div>
                <div class="col-md-12 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Project Description</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
            </div>
            <div class="row px-4">
                <div class="col-md-4 col-12">
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">Channels</h4>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Branches</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2">Visits</h4>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">05</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Call Center</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">02</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Social Media</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Portal</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <div class="ms-plus-btn ms-ml-05 my-3">
                                <i class="pi pi-plus-circle"></i>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-8 col-12">
                    <div class="grey-box">
                        <div class="column">
                            <h5 class="medium-h my-2">Measuring Type</h5>
                            <input type="text" class="form-control ms-input-white" placeholder="for example"
                                id="exampleInputEmail1" aria-describedby="emailHelp">
                        </div>
                        <div class="my-5">
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                01
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                02
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                03
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12">
                    <div class="grey-box">
                        <div class="d-flex align-items-end">
                            <div class="column width-100">
                                <h5 class="medium-h my-2">Project Goals</h5>
                                <input type="text" class="form-control ms-input-white" placeholder="for example"
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                            <div class="ms-plus-btn mx-2">
                                <i class="pi pi-plus-circle"></i>
                            </div>
                        </div>
                        <div class="ms-my-top-bottom-5">
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                01
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                02
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                03
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section>
<!-- SECTION PAGE 3 End -->

<!-- SECTION PAGE 4 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Assign Weight For Channels</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row px-4">
                <div class="col-md-6 col-12">
                    <div>
                        <h4 class="semi-h-pg-4">Channels Weight</h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">Channels</h4>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Branches</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2">Weights</h4>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">05</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Call Center</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">02</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Social Media</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Portal</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div>
                        <h4 class="semi-h-pg-4">Branches Weight</h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">Branches</h4>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Branches</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2">Weight</h4>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">05</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Call Center</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">02</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box-circle">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Social Media</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box-circle">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Portal</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section>
<!-- SECTION PAGE 4 End -->

<!-- SECTION PAGE 5 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div>
                <h4 class="semi-h-pg-4">Main Criteria's</h4>
            </div>
            <div class="grey-box">
                <div class="row px-4">
                    <div class="col-md-4 col-12">
                        <div>
                            <div>
                                <h4 class="medium-h my-2">Channel</h4>
                                <div>
                                    <select class="ms-dropdown-pg-5">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="width-100">
                                    <div class="white-box-check">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex">
                                                <div class="ms-check-box">
                                                    <i class="pi pi-check"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-wrap">
                                                <div class="ms-check-box-name">Call Center</div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex">
                                <div class="width-100">
                                    <div class="white-box-check">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex">
                                                <div class="ms-check-box">
                                                    <i class="pi pi-check"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-wrap">
                                                <div class="ms-check-box-name">Call Center</div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex">
                                <div class="width-100">
                                    <div class="white-box-check">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex">
                                                <div class="ms-check-box">
                                                    <i class="pi pi-check"></i>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-wrap">
                                                <div class="ms-check-box-name">Call Center</div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div class="col-md-8 col-12">
                        <div>
                            <div class="d-flex">
                                <div class="width-100">
                                    <h4 class="medium-h my-2">Criteria</h4>
                                    <div class="d-flex align-items-baseline">
                                        <input type="text" class="form-control ms-input-white-pg-5"
                                            placeholder="for example" id="exampleInputEmail1"
                                            aria-describedby="emailHelp">
                                        <div>
                                            <div class="ms-plus-btn mx-2">
                                                <i class="pi pi-plus-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                01
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>

                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                02
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>

                            <div class="white-box-check">
                                <div class="custom-flex-pg-3">
                                    <div class="d-flex align-items-center mob-m-tb-pg-3">
                                        <div class="d-flex">
                                            <div class="ms-check-box-font-400">
                                                03
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">for example</div>
                                        </div>
                                    </div>
                                    <div class="d-flex mob-m-tb-pg-3">
                                        <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section>
<!-- SECTION PAGE 5 End -->

<!-- SECTION PAGE 6 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div>
                <h4 class="semi-h-pg-4">Sub Criteria's</h4>
            </div>
            <div class="grey-box">
                <div class="row pg-6-px-4">
                    <div class="col-md-4 col-12">
                        <div>
                            <h4 class="medium-h my-2">Main Criteria's</h4>
                            <div>
                                <select class="ms-dropdown-pg-5">
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-12">
                        <div>
                            <div class="width-100">
                                <h4 class="medium-h my-2">Sub Criteria</h4>
                                <div class="d-flex align-items-baseline">
                                    <input type="text" class="form-control ms-input-white-pg-5"
                                        placeholder="for example" id="exampleInputEmail1" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pg-6-px-4">
                    <div class="col-md-8 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">Measuring Name</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5" placeholder="for example"
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div>
                            <div class="d-flex">
                                <div class="width-100">
                                    <h4 class="medium-h my-2">Measuring Type</h4>
                                    <div class="d-flex align-items-baseline">
                                        <input type="text" class="form-control ms-input-white-pg-5"
                                            placeholder="for example" id="exampleInputEmail1"
                                            aria-describedby="emailHelp">
                                        <div>
                                            <div class="ms-plus-btn mx-2">
                                                <i class="pi pi-plus-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pg-6-px-4">
                    <div class="col-md-12 col-12">
                        <div class="white-box-check">
                            <div class="custom-flex-pg-3">
                                <div class="d-flex align-items-center mob-m-tb-pg-3">
                                    <div class="d-flex">
                                        <div class="ms-check-box-font-400">
                                            01
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap">
                                        <div class="ms-check-box-name">for example</div>
                                    </div>
                                </div>
                                <div class="d-flex mob-m-tb-pg-3">
                                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                </div>
                            </div>
                        </div>

                        <div class="white-box-check">
                            <div class="custom-flex-pg-3">
                                <div class="d-flex align-items-center mob-m-tb-pg-3">
                                    <div class="d-flex">
                                        <div class="ms-check-box-font-400">
                                            02
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap">
                                        <div class="ms-check-box-name">for example</div>
                                    </div>
                                </div>
                                <div class="d-flex mob-m-tb-pg-3">
                                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                </div>
                            </div>
                        </div>

                        <div class="white-box-check">
                            <div class="custom-flex-pg-3">
                                <div class="d-flex align-items-center mob-m-tb-pg-3">
                                    <div class="d-flex">
                                        <div class="ms-check-box-font-400">
                                            03
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap">
                                        <div class="ms-check-box-name">for example</div>
                                    </div>
                                </div>
                                <div class="d-flex mob-m-tb-pg-3">
                                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="d-flex justify-content-end">
            <button style="display: none;" class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="submmit-btn">Create</button>
        </div>

        <div class="white-box">
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Main Criteria's</th>
                            <th scope="col">Sub Criteria's</th>
                            <th scope="col">Factor</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                04
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section>
<!-- SECTION PAGE 6 End -->

<!-- SECTION PAGE 7 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div>
                <h4 class="semi-h-pg-4">Enquiries</h4>
            </div>
            <div class="grey-box">
                <div class="row pg-6-px-4">
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">Enquiry</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5" placeholder="for example"
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">Correct Answer</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5" placeholder="for example"
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div>
                            <h4 class="medium-h my-2">Factor</h4>
                            <div>
                                <select class="ms-dropdown-pg-5">
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                    <option [value]="'option'">option</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="width-100">
                            <h4 class="medium-h my-2">Service URL</h4>
                            <div class="d-flex align-items-baseline">
                                <input type="text" class="form-control ms-input-white-pg-5" placeholder="for example"
                                    id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end">
            <button style="display: none;" class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="submmit-btn">Create</button>
        </div>

        <div class="white-box">
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Main Criteria's</th>
                            <th scope="col">Sub Criteria's</th>
                            <th scope="col">Factor</th>
                            <th scope="col">Service URL</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">KgateBc.gov.sa/All</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">KgateBc.gov.sa/All</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">KgateBc.gov.sa/All</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                04
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">KgateBc.gov.sa/All</div>
                                </span></td>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tabel-btn-white-box mob-m-tb-pg-3">
                                        <div class="tabel-circle-btn"><i class="fa fa-trash"></i></div>
                                        <div class="tabel-circle-btn"><i class="fa fa-pencil"></i></div>
                                    </div>
                                </span></td>
                        </tr>



                    </tbody>
                </table>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 7 End -->

<!-- SECTION PAGE 8 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Visit Calander</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
           <div class="d-flex justify-content-center">
            <div class="max-width-1400">
                <div class="d-flex justify-content-start flex-wrap">
                    <div class="calender-day-box">Monday</div>
                    <div class="calender-day-box">Tuesday</div>
                    <div class="calender-day-box">Wednesday</div>
                    <div class="calender-day-box">Thursday</div>
                    <div class="calender-day-box">Friday</div>
                    <div class="calender-day-box">Saturday</div>
                    <div class="calender-day-box">Sunday</div>
                   </div>
                   <div class="d-flex justify-content-start flex-wrap my-3">
                       <div class="calender-number-box-active">
                           <div class="calender-postition-number">
                               01
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               02
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               03
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               04
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               05
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               06
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               07
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               08
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               09
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               10
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               11
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               12
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               13
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               14
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               15
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               16
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               17
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               18
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               19
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               20
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               21
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               22
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               23
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               24
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               25
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               26
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               27
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               28
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               29
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               30
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               31
                           </div>
                       </div>
       
                      </div>
               </div>
           </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button style="display: none;" class="submmit-btn">Create</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 8 End -->

<!-- SECTION PAGE 9 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Visit Calander</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
           <div class="d-flex justify-content-center">
            <div class="max-width-1400">
                <div class="d-flex justify-content-start flex-wrap my-3">
                    <div class="calender-day-box">Monday</div>
                    <div class="calender-day-box">Tuesday</div>
                    <div class="calender-day-box">Wednesday</div>
                    <div class="calender-day-box">Thursday</div>
                    <div class="calender-day-box">Friday</div>
                    <div class="calender-day-box">Saturday</div>
                    <div class="calender-day-box">Sunday</div>
                   </div>
                   <div class="d-flex justify-content-start flex-wrap">
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               01
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               02
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               03
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               04
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               05
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               06
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               07
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               08
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               09
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               10
                           </div>
                       </div>
                       <div class="calender-number-box-active">
                           <div class="calender-postition-number">
                               11
                           </div>
                           <div class="calender-number-box-active-details">Visit details channel "as visit time"</div> 
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               12
                           </div>
                       </div>
                       <div class="calender-number-box-active">
                           <div class="calender-postition-number">
                               13
                           </div>
                           <div class="calender-number-box-active-details">Visit details channel "as visit time"</div> 
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               14
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               15
                           </div>
                       </div>
                       <div class="calender-number-box-active">
                           <div class="calender-postition-number">
                               16
                           </div>
                           <div class="calender-number-box-active-details">Visit details channel as visit time Visit details channel as visit time Visit details channel as 
                            visit time Visit details channel as visit time Visit details channel as visit time Visit details channel as visit time</div> 
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               17
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               18
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               19
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               20
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               21
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               22
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               23
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               24
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               25
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               26
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               27
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               28
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               29
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               30
                           </div>
                       </div>
                       <div class="calender-number-box">
                           <div class="calender-postition-number">
                               31
                           </div>
                       </div>
       
                      </div>
                      <div class="my-4 bg-comment-color mx-1">
                        <h5 class="medium-h p-3">Approve comment</h5>
                        <input class="ms-input-textarea" type="textarea" placeholder="">
                      </div>
               </div>
           </div>
        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 9 End -->

<!-- SECTION PAGE 10 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Visit Schedule Approval</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row px-4">
                <div class="col-md-6 col-12">
                    <div>
                        <h4 class="semi-h-pg-4">Channels Weight</h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">Channels</h4>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Branches</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2">Weights</h4>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">05</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Call Center</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">02</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Social Media</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name-pg-4">Portal</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div>
                        <h4 class="semi-h-pg-4">Branches Weight</h4>
                    </div>
                    <div class="grey-box">
                        <div class="d-flex">
                            <div class="width-100">
                                <h4 class="medium-h my-2">Branches</h4>
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Branches</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 class="medium-h mx-2 my-2">Weight</h4>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">05</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-check-box">
                                                <i class="pi pi-check"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Call Center</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">02</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box-circle">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Social Media</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex">
                            <div class="width-100">
                                <div class="white-box-check">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex">
                                            <div class="ms-no-check-box-circle">
                                                <i class="pi pi-x"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">Portal</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="white-box-no-visits">
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex flex-wrap">
                                            <div class="ms-check-box-name">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="my-4 bg-comment-color mx-3">
                <h5 class="medium-h p-3">Approve comment</h5>
                <input class="ms-input-textarea" type="textarea" placeholder="">
            </div>

        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn">Approve</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 10 End -->

<!-- SECTION PAGE 11 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <h4 class="semi-h-pg-4">Criteria's List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Main Criteria's</th>
                            <th scope="col">Sub Criteria's</th>
                            <th scope="col">Factor</th>
                            <th scope="col">Responsible</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Responsible"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Responsible</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Main Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Sub Criteria"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Responsible"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Responsible</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="my-4 bg-comment-color">
                <h5 class="medium-h p-3">Approve comment</h5>
                <input class="ms-input-textarea" type="textarea" placeholder="">
            </div>
        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn">Approve</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

        <div class="white-box">
            <h4 class="semi-h-pg-4">Enquries for the Mistry Shopper</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Enquire</th>
                            <th scope="col">Correct Answer</th>
                            <th scope="col">Service URL</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquire"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Correct Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Correct Answer</div>
                                </span></td>
                            <td data-label="Service URL"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Service URL</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquire"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Main Criteria</div>
                                </span></td>
                            <td data-label="Correct Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Correct Answer</div>
                                </span></td>
                            <td data-label="Service URL"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Service URL</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="my-4 bg-comment-color">
                <h5 class="medium-h p-3">Approve comment</h5>
                <input class="ms-input-textarea" type="textarea" placeholder="">
            </div>
        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn">Approve</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 11 End -->

<!-- SECTION PAGE 12 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">

            <div class="grey-box">
             <div class="row">
                <div class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">Channel</h4>
                        <div>
                            <select class="ms-dropdown-pg-12">
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">Branches</h4>
                        <div>
                            <select class="ms-dropdown-pg-12">
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div>
                        <h4 class="medium-h my-2">Visit Time</h4>
                        <div>
                            <select class="ms-dropdown-pg-12">
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                                <option [value]="'option'">option</option>
                            </select>
                        </div>
                    </div>
                </div>
             </div>
            </div>

            <h4 class="medium-h my-4 mx-2">Enquiries List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Enquries List</th>
                            <th scope="col">Employee Answer</th>
                            <th scope="col">Mistery shoper comment</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Mistery shoper comment"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Mistery shoper comment"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <h4 class="medium-h my-4 mx-2">Factor List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Factor</th>
                            <th scope="col">5/Grade</th>
                            <th scope="col">Comments</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>


        </div>


        <div class="d-flex justify-content-right">
            <button class="next-btn">Approve</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 12 End -->

<!-- SECTION PAGE 13 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Enquiries & Criteria's</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Branch name (Appears only if Channel=Branches)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Visit Date/Time
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">

            <h4 class="medium-h my-4 mx-2">Enquiries List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Enquries List</th>
                            <th scope="col">Employee Answer</th>
                            <th scope="col">Mistery shoper comment</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Mistery shoper comment"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                            <td data-label="Mistery shoper comment"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <h4 class="medium-h my-4 mx-2">Factor List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Factor</th>
                            <th scope="col">5/Grade</th>
                            <th scope="col">Percentage</th>
                            <th scope="col">Comments</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%100</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Enquries List"><span class="ms-tabel-td-mob-mr">
                                <div>
                                    <select class="ms-dropdown-pg-12-table">
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                        <option [value]="'option'">option</option>
                                    </select>
                                </div>
                                </span></td>
                            <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%100</div>
                                </span></td>
                                <td data-label="Employee Answer"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Sub Criteria</div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div class="my-4">
                <input class="ms-input-textarea-pg-13" type="textarea" placeholder="Comment entered by external PM">
            </div>
            <div class="my-4">
                <input class="ms-input-textarea-pg-13" type="textarea" placeholder="Comment entered by external PM">
            </div>

        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn">Approve</button>
            <button class="re-do-btn mx-2"><i class="fa-solid fa-arrows-rotate mx-2"></i>Re-Do</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 13 End -->

<!-- SECTION PAGE 14 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Dashboard</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">06</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Done</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">05</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Challenge</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">0</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Pending</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">03</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">On-Hold</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">35</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Pending</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">07</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Reject</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="grey-box">
                        <h4 class="dashboard-medium-h">Pending</h4>
                       <div class="d-flex">
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Factor</div>
                            <div class="dashboard-white-box">01 Factor</div>
                            <div class="dashboard-white-box">02 Factor</div>
                        </div>
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Channel</div>
                            <div class="dashboard-white-box">Portal</div>
                            <div class="dashboard-white-box">Call Center</div>
                        </div>
                       </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="grey-box">
                        <h4 class="dashboard-medium-h">In-Progress</h4>
                       <div class="d-flex">
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Factor</div>
                            <div class="dashboard-white-box">01 Factor</div>
                            <div class="dashboard-white-box">02 Factor</div>
                        </div>
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Channel</div>
                            <div class="dashboard-white-box">Portal</div>
                            <div class="dashboard-white-box">Call Center</div>
                        </div>
                       </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="grey-box">
                        <h4 class="dashboard-medium-h">Challenge</h4>
                       <div class="d-flex">
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Factor</div>
                            <div class="dashboard-white-box">01 Factor</div>
                            <div class="dashboard-white-box">02 Factor</div>
                        </div>
                        <div class="width-100 m-1">
                            <div class="dashboard-purple-box">Channel</div>
                            <div class="dashboard-white-box">Portal</div>
                            <div class="dashboard-white-box">Call Center</div>
                        </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 14 End -->

<!-- SECTION PAGE 15 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Forwarding</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Branch name (Appears only if Channel=Branches)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Visit Date/Time
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">

            <h4 class="medium-h my-4 mx-2">Factor List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Factor</th>
                            <th scope="col">Percentage</th>
                            <th scope="col">Mistry Shopper comments</th>
                            <th scope="col">Forward</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Percentage"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%05</div>
                                </span></td>
                            <td data-label="Mistry Shopper comments"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Comment entered by the external PM</div>
                                </span></td>
                            <td data-label="Forward"><span class="ms-tabel-td-mob-mr">
                                    <div>
                                        <select class="ms-dropdown-pg-12-table">
                                            <option [value]="'option'">Responsible</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                        </select>
                                    </div>
                                </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                            <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Percentage"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%05</div>
                                </span></td>
                            <td data-label="Mistry Shopper comments"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Comment entered by the external PM</div>
                                </span></td>
                            <td data-label="Forward"><span class="ms-tabel-td-mob-mr">
                                    <div>
                                        <select class="ms-dropdown-pg-12-table">
                                            <option [value]="'option'">Responsible</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                        </select>
                                    </div>
                                </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
        </div>

    </div>
</section>
<!-- SECTION PAGE 15 End -->

<!-- SECTION PAGE 16 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Update Factor Status</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row">
                <h4 class="medium-h mx-2 my-2">Project Details</h4>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Project Name
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-md-4 col-12 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Start Date / End Date
                                </div>
                            </div>
                            <div class="col-md-8 col-12 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    <div class="d-flex justify-content-between mob-my-2-pg-4">
                                        <div>10-08-2023</div>
                                        <div class="d-flex align-items-center mx-2">
                                            <i class="full-stop"></i>
                                            <div class="time-bar"></div>
                                            <i class="pi pi-arrow-left icon-purple"></i>
                                        </div>
                                        <div>10-08-2023</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Branches
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-4 m-0 p-0 d-flex justify-content-start">
                                <div class="project-title-pg-4">
                                    Channel
                                </div>
                            </div>
                            <div class="col-8 m-0 p-0 d-flex justify-content-center">
                                <div class="project-name-pg-4">
                                    Zairdokidis
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Branch name (Appears only if Channel=Branches)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="detail-box-pg-4-header">
                        <div class="row m-0 p-0 d-flex align-items-center">
                            <div class="col-12 m-0 p-0">
                                <div class="project-title-pg-13">
                                    Visit Date/Time
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">

            <h4 class="medium-h my-4 mx-2">Factor List</h4>
            <div class="grey-box">
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Factor</th>
                            <th scope="col">Percentage</th>
                            <th scope="col">Mistry Shopper comments</th>
                            <th scope="col">Forward</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                                <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Percentage"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%05</div>
                                </span></td>
                                <td data-label="Mistry Shopper comments"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Comment entered by the external PM</div>
                                </span></td>
                                <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                                <td data-label="Forward"><span class="ms-tabel-td-mob-mr">
                                    <div>
                                        <select class="ms-dropdown-pg-12-table">
                                            <option [value]="'option'">Responsible</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                        </select>
                                    </div>
                                    </span></td>
                        </tr>

                        <tr>
                            <td data-label=""><span class="ms-tabel-td-mob-mr">
                                    <div class="d-flex tab-num-border-white">
                                        <div>
                                            <div class="ms-tabel-num-box">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </span></td>
                                <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                            <td data-label="Percentage"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">%05</div>
                                </span></td>
                                <td data-label="Mistry Shopper comments"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Comment entered by the external PM</div>
                                </span></td>
                                <td data-label="Factor"><span class="ms-tabel-td-mob-mr">
                                    <div class="tabel-detail-box">Factor</div>
                                </span></td>
                                <td data-label="Forward"><span class="ms-tabel-td-mob-mr">
                                    <div>
                                        <select class="ms-dropdown-pg-12-table">
                                            <option [value]="'option'">Responsible</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                            <option [value]="'option'">option</option>
                                        </select>
                                    </div>
                                    </span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>

        <div class="d-flex justify-content-right">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 16 End -->

<!-- SECTION PAGE 22 Start-->
 <section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Dashboard-Reports</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="grey-box">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">Vendor</h5>
                            <div>
                                <select class="ms-dropdown-pg-22">
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                </select>
                              </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">Factor Status</h5>
                            <div>
                                <select class="ms-dropdown-pg-22">
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                </select>
                              </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">Channel</h5>
                            <div>
                                <select class="ms-dropdown-pg-22">
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                  <option [value]="'option'">option</option>
                                </select>
                              </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="d-flex width-100">
                            <div class="column my-2 pg-22-margin width-100">
                                <h5 class="medium-h">Data</h5>
                                <div>
                                    <select class="ms-dropdown-pg-22">
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                    </select>
                                  </div>
                            </div>
                            <div class="column my-2 width-100">
                                <h5 class="medium-h">Mobile</h5>
                                <div>
                                    <select class="ms-dropdown-pg-22">
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                      <option [value]="'option'">option</option>
                                    </select>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">06</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Done</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">05</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Challenge</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">0</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Pending</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">03</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">On-Hold</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">35</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Pending</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6 col-6">
                    <div class="dashboard-grey-box">
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">07</h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">Reject</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section> 
<!-- SECTION PAGE 22 End -->

<!-- SECTION PAGE 23 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Dashboard-Reports</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row db-p-05 mob-padding-pg-24">
                <div class="col-md-12 col-12 db-p-05">
                    <div class="row db-p-05">
                        <div class="col-md-3 col-6 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-house-laptop mx-2"></i></span>
                                    <span class="font-24-8">E-Service</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-phone mx-2"></i></span>
                                    <span class="font-24-8">Call center</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-building-wheat mx-2"></i></span>
                                    <span class="font-24-8">Branches</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-6 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-house-laptop mx-2"></i></span>
                                    <span class="font-24-8">E-Service</span>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-12 col-12 db-p-05">
                                <div class="row db-p-05">
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Call</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">68</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Call</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">44</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs d-flex width-100 align-items-center">
                                                <div class="d-flex justify-content-between align-items-center width-100">
                                                    <div class="box-with-num-text">
                                                        <p class="grey-box-text">Out Kingdom</p>
                                                    <span class="font-23-8 text-start">012568543894</span>
                                                    </div>
                                                    <div class="box-with-num-text">
                                                        <p class="grey-box-text">In Kingdom</p>
                                                    <span class="font-23-8 text-start">2022154</span>
                                                    </div>
                                                </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-3 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                    </div> 
                </div>

            </div>
            <div class="row db-p-05 mob-padding-pg-24">
                <div class="col-md-6 col-12 db-p-05">
                    <div class="purple-box d-flex justify-content-center align-items-center">
                            <div>
                                <p class="grey-box-text">Total Targets of the project</p>
                            </div>
                    </div>
                </div>
                <div class="col-md-6 col-12 db-p-05">
                    <div class="purple-box d-flex justify-content-center align-items-center">
                            <div>
                                <p class="grey-box-text">Scope</p>
                            </div>
                    </div>
                </div>
            </div>
            
            <div class="grey-box mob-padding-pg-24 ccccc">
                <div class="row db-p-05">
                    <div class="col-lg-5 col-md-12 col-12 db-p-05">
                        <h4 class="dashboard-medium-h-24">Main Criteria's</h4>

                     <div class="w-h-fill">
                        <img class="dummy-work" src="../../assets/bg/Capture.PNG" alt="loading">
                     </div>
                    </div>
                    <div class="col-lg-7 col-md-12 col-12 db-p-05">
                        <h4 class="dashboard-medium-h-24">Unassigned Factors</h4>
                        <div class="flex-23">
                         <div class="m-1">
                             <div class="dashboard-purple-box-23 mb-3">#</div>
                             <div class="dashboard-white-box-23">01</div>
                             <div class="dashboard-white-box-23">02</div>
                             <div class="dashboard-white-box-23">03</div>
                             <div class="dashboard-white-box-23">04</div>
                         </div>
                         <div class="width-100 m-1">
                             <div class="dashboard-purple-box mb-3 text-center">Weight</div>
                             <div class="dashboard-white-box text-center">40%</div>
                             <div class="dashboard-white-box text-center">35%</div>
                             <div class="dashboard-white-box text-center">30%</div>
                             <div class="dashboard-white-box text-center">25%</div>
                         </div>
                         <div class="width-100 m-1">
                            <div class="dashboard-purple-box mb-3 text-center">Grade%</div>
                            <div class="dashboard-white-box text-center">31.2%</div>
                            <div class="dashboard-white-box text-center">21.5%</div>
                            <div class="dashboard-white-box text-center">99.7%</div>
                            <div class="dashboard-white-box text-center">01.9%</div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section>
<!-- SECTION PAGE 23 End -->

<!-- SECTION PAGE 24 Start-->
<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">Dashboard-Reports</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num">02</span>
                        <span class="pg-num-active">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row db-p-05 mob-padding-pg-24">
                <div class="col-md-9 col-12 db-p-05">
                    <div class="row db-p-05">
                        <div class="col-md-4 col-4 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-house-laptop mx-2"></i></span>
                                    <span class="font-24-8">E-Service</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-phone mx-2"></i></span>
                                    <span class="font-24-8">Call center</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-4 db-p-05">
                            <div class="d-flex justify-content-center">
                                <div class="main-db-tabs column-24">
                                    <span><i class="fa-solid fa-building-wheat mx-2"></i></span>
                                    <span class="font-24-8">Branches</span>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-12 col-12 db-p-05">
                                <div class="row db-p-05">
                                    <div class="col-md-4 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Call</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">68</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-4 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Call</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">44</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-4 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs">
                                            <p class="grey-box-text">Visit</p>
                                            <div class="d-flex justify-content-end">
                                                <span class="long-box-num">16</span>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-4 col-6 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs d-flex width-100 align-items-center">
                                                <div class="d-flex justify-content-between align-items-center width-100">
                                                    <div class="box-with-num-text">
                                                        <p class="grey-box-text">Social Media</p>
                                                    <span class="font-24-8 text-start">Inspection</span>
                                                    </div>
                                                    <div class="long-box-num">48</div>
                                                </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-8 col-12 grey-box-flex db-p-05">
                                        <div class="main-db-grey-tabs d-flex align-items-center justify-content-center">
                                            <div class="d-flex flex-wrap justify-content-center">
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-brands fa-youtube mx-3 mt-1 color-5"></i>
                                                    <span class="color-5">07</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-regular fa-envelope mx-3 mt-1 color-4"></i>
                                                    <span class="color-4">06</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-brands fa-twitter mx-3 mt-1 color-3"></i>
                                                    <span class="color-3">09</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-brands fa-linkedin-in mx-3 mt-1 color-2"></i>
                                                    <span class="color-2">02</span>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="fa-brands fa-instagram mx-3 mt-1 color-1"></i>
                                                    <span class="color-1">08</span>
                                                </div>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                    </div> 
                </div>
                <div class="col-md-3 col-12 db-p-05 mt-1">
                    <div class="db-p-05">
                        <div class="main-db-long-tabs">
                            <p class="long-box-text">Total Service insperation in all Channels</p>
                            <div class="long-box-flex">
                                <span>Service</span>
                                <span class="long-box-num">159</span>
                            </div>
                        </div>
                    </div>
                    <div class="db-p-05">
                        <div class="main-db-long-tabs-2">
                            <p class="long-box-text">Branches</p>
                                <div class="long-box-flex">
                                    <span>blank</span>
                                    <span class="long-box-num">16</span>
                                </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row db-p-05 mob-padding-pg-24">
                <div class="col-md-6 col-12 db-p-05">
                    <div class="blue-box">
                        <div class="d-flex justify-content-center">
                            <div class="d-flex align-items-center">
                                <p class="grey-box-text mt-2 mx-2">Total Inspection of Mistry Shopper</p>
                                <div class="long-box-num">48</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-12 db-p-05">
                    <div class="purple-box d-flex justify-content-center align-items-center">
                            <div>
                                <p class="grey-box-text">Total Targets of the project</p>
                            </div>
                    </div>
                </div>
            </div>
            
            <div class="grey-box mob-padding-pg-24 xxxxx">
                <div class="row db-p-05">
                    <div class="col-lg-5 col-md-6 col-12 db-p-05">
                        <h4 class="dashboard-medium-h-24">Channels Grade With Weight</h4>
                        <div class="flex-24">
                         <div class="width-100 m-1">
                             <div class="dashboard-purple-box mb-3">Channels</div>
                             <div class="dashboard-white-box">Branches</div>
                             <div class="dashboard-white-box">Call Center</div>
                             <div class="dashboard-white-box">Portal</div>
                             <div class="dashboard-white-box">Social Media</div>
                         </div>
                         <div class="width-100 m-1">
                             <div class="dashboard-purple-box mb-3 text-center">Weight</div>
                             <div class="dashboard-white-box text-center">40%</div>
                             <div class="dashboard-white-box text-center">35%</div>
                             <div class="dashboard-white-box text-center">30%</div>
                             <div class="dashboard-white-box text-center">25%</div>
                         </div>
                         <div class="width-100 m-1">
                            <div class="dashboard-purple-box mb-3 text-center">Grade%</div>
                            <div class="dashboard-white-box text-center">31.2%</div>
                            <div class="dashboard-white-box text-center">21.5%</div>
                            <div class="dashboard-white-box text-center">99.7%</div>
                            <div class="dashboard-white-box text-center">01.9%</div>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-6 col-12 db-p-05">
                        <h4 class="dashboard-medium-h-24">Main Criteria's</h4>

                     <div class="w-h-fill">
                        <img class="dummy-work" src="../../assets/bg/Capture.PNG" alt="loading">
                     </div>
                    </div>
                    <div class="col-lg-2 col-md-6 col-12 db-p-05">
                        <h4 class="dashboard-medium-h-24">SBC General Grade</h4>

                        <div class="w-h-fill">
                            <img class="dummy-work" src="../../assets/bg/Capturezz.PNG" alt="loading">
                         </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section>
<!-- SECTION PAGE 24 End -->









<!-- 

<app-footer></app-footer> -->